import useWindowPositionTop from 'hooks/useWindowPositionTop';
export default function SpokenEnglish() {
    useWindowPositionTop();
  return (
    <>
      <style>{`
        .conversational-course {
          white-space: pre-line;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          margin: 0 auto;
          padding: 8rem 2rem;
          box-sizing: border-box;
          background: #fff;
          color: #222;
          border-radius: 8px;
          transition: padding 0.3s ease;
          max-width: 720px;
        }

        .conversational-course h2 {
          font-size: 2.25rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #003366;
          line-height: 1.1;
        }

        .conversational-course p {
          margin-bottom: 1.25rem;
          font-size: 1.125rem;
          font-weight: 400;
          color: #333;
        }

        .conversational-course ul {
          margin-bottom: 1.75rem;
          padding-left: 1.5rem;
          list-style-type: disc;
          color: #444;
        }

        .conversational-course ul li {
          margin-bottom: 0.6rem;
          font-size: 1.05rem;
          line-height: 1.4;
        }

        .conversational-course strong {
          font-weight: 700;
          color: #002244;
        }

        .conversational-course .highlight {
          font-weight: 700;
          font-size: 1.2rem;
          color: #b22222;
          margin-top: 2rem;
        }

        /* Responsive typography and spacing */
        @media (max-width: 1024px) {
          .conversational-course h2 {
            font-size: 1.9rem;
          }
          .conversational-course p,
          .conversational-course ul li {
            font-size: 1rem;
          }
        }

        @media (max-width: 600px) {
          .conversational-course h2 {
            font-size: 1.6rem;
          }
          .conversational-course p,
          .conversational-course ul li {
            font-size: 0.95rem;
          }
          .conversational-course ul {
            padding-left: 1.2rem;
          }
        }

        @media (max-width: 360px) {
          .conversational-course h2 {
            font-size: 1.4rem;
          }
          .conversational-course p,
          .conversational-course ul li {
            font-size: 0.9rem;
          }
        }
      `}</style>

      <div className="conversational-course">
        <h2>РАЗГОВОРНЫЙ КУРС</h2>
        <p>
          Заговори на английском языке в сжатые сроки. Без толстых учебников, без воды, без нудных длительных упражнений и прочей фигни. 😁
        </p>
        <p>Вы или Ваш ребёнок начнёте <strong>ГОВОРИТЬ НА АНГЛИЙСКОМ С ПЕРВОГО УРОКА!</strong></p>
        <p>
          Разговорный курс английского языка — ваш прямой билет в мир свободного общения!
        </p>

        <p><strong>Почему этот курс — это именно то, что вам нужно:</strong></p>
        <ul>
          <li>✨ Живое общение с первого дня — никаких долгих прелюдий, говорим сразу как в детстве</li>
          <li>Реальные разговорные ситуации</li>
          <li>Просмотр и разбор фильмов, мультфильмов и песен на английском языке</li>
          <li>Естественная языковая практика</li>
        </ul>

        <p><strong>🚀 Быстрые результаты:</strong></p>
        <ul>
          <li>Заметный прогресс уже через 2-3 занятия</li>
          <li>Уверенность в общении с носителями</li>
          <li>Расширение активного словарного запаса</li>
        </ul>

        <p><strong>🎯 Практический подход:</strong></p>
        <ul>
          <li>Только полезные разговорные темы</li>
          <li>Постоянный просмотр отрывков из фильмов и мультфильмов на английском языке</li>
          <li>Повседневное общение</li>
        </ul>

        <p><strong>🏆 Что вы получите:</strong></p>
        <ul>
          <li>Избавитесь от синдрома «понимаю, но сказать не могу»</li>
          <li>Свободно овладеете разговорной речью</li>
          <li>Обретёте уверенность при публичных выступлениях</li>
          <li>Начнёте понимать живую речь носителей</li>
          <li>Обретёте способность выражать мысли без пауз</li>
          <li>Сможете смотреть фильмы в оригинале без субтитров</li>
          <li>Будете путешествовать без переводчика</li>
        </ul>

        <p><strong>Особенности формата:</strong></p>
        <ul>
          <li>Индивидуальные занятия</li>
          <li>Занятия в парах</li>
          <li>Занятия в мини-группах (до 4 человек)</li>
        </ul>

        <p><strong>Стоимость занятий:</strong></p>
        <ul>
          <li>Индивидуальное занятие — 1600 р./60 минут</li>
          <li>Занятие в паре — 1000 р./60 минут</li>
          <li>Занятие в мини-группе — 800 р./60 минут</li>
        </ul>

        <p>
          Для разговорного курса минимальный уровень владения английским — A2
        </p>
      </div>
    </>
  );
}

